<template>
  <TempPageVue>
    <template v-slot:left>
      <div class="col-lg-3">
        <UserFeedInfoVue
          ref="userFeed"
          props_selectItem="MyDynamic"
        ></UserFeedInfoVue>
      </div>
    </template>
    <template v-slot:content>
      <div class="col-lg-6 infoEnd">
        <div class="row">
          <div class="col-12">
            <div id="feed-wall" v-loading="loading">
              <transition-group name="el-fade-in-linear">
                <!-- Feed Post -->
                <div
                  class="feedpost card"
                  v-for="item in socialData"
                  :key="item.id"
                  v-show="socialData != null && socialData.length > 0"
                >
                  <ReportMaskVue
                    v-if="item != null && item.sgL_IsShow == null"
                    class="mask"
                  ></ReportMaskVue>
                  <div
                    class="card-body pt-2 pb-0 px-2"
                    :class="{
                      hideBtn: item != null && item.sgL_IsShow == null,
                    }"
                  >
                    <FeedCardVue
                      :item="item"
                      :ref="'feedCard' + item.id"
                      :playerOptions="playerOptions[item.id]"
                      :shareurl="$parent.shareurl"
                      @collectFunc="$parent.collectFunc"
                      @reportFunc="$parent.reportFunc"
                      @deleteFunc="$parent.deleteFunc"
                      @onPlayerPlay="$parent.onPlayerPlay"
                      @likeFunc="$parent.likeFunc"
                      @commentShow="commentShow"
                      @submitComment="submitComment"
                      @updateStatistics="$parent.updateStatistics"
                      @viewInfo="$parent.viewInfo"
                    ></FeedCardVue>
                  </div>
                </div>
              </transition-group>
              <div v-show="socialData == null || socialData.length == 0">
                <div class="empty-block">
                  <div class="empty-block-inner">
                    {{ $t('Social.MyDynamic.msg') }}
                  </div>
                </div>
              </div>

              <!-- /.feed post -->
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:right>
      <div class="col-lg-3 col">
        <CreateFeedVue
          ref="creFeed"
          @saveFeed="$parent.saveFeed"
          @checkIsCert="$parent.checkIsCert"
        ></CreateFeedVue>
      </div>
    </template>
  </TempPageVue>
</template>

<script>
import FeedCardVue from "./FeedCard.vue";
import bases from "../../api/httpApi/base";
import socialTool from "../../assets/js/socialJs/tool";
import TempPageVue from "./TempPage.vue";
import CreateFeedVue from "./CreateFeed.vue";
import UserFeedInfoVue from "./UserFeedInfo.vue";
import ReportMaskVue from "./ReportMask.vue";

let currentPage = 0;
let limit = 5;
let isLoading = false;

export default {
  components: {
    FeedCardVue,
    TempPageVue,
    CreateFeedVue,
    UserFeedInfoVue,
    ReportMaskVue,
  },
  data() {
    return {
      //shareurl: `${this.$shareUrl}${bases.url}/Home/facebookResp`,
      socialData: [],
      loading: false,
      scrollParam: null,
      playerOptions: {},
      noChangeVideoList: [],
      currentPlayer: null,
    };
  },
  methods: {
    async commentShow(item) {
      let data = await this.$parent.qryComment(item);
      let commentItem = eval("this.$refs.feedCard" + item.id)[0];
      commentItem.setCommentData(data);
    },
    submitComment(item, content) {
      this.$parent.submitComment(item, content, this.commentShow);
    },
    getPageData(isRefresh) {
      if (isRefresh) {
        currentPage = 0;
        limit = 5;
      }
      isLoading = true;
      this.loading = true;
      this.socialData = [];
      let params = {
        SGL_Type: -1,
        IsLogin: true,
        SkipCount: currentPage,
        MaxResultCount: limit,
        SGL_IsShow: true,
      };
      this.scrollParam = params;
      this.$api.social
        .GetMySocialData(params)
        .then((res) => {
          if (res.data.success) {
            socialTool.setPlayerOptions(
              this.playerOptions,
              this.noChangeVideoList,
              res.data.result.items,
              1
            );
            this.socialData = res.data.result.items;
            isLoading = false;
          } else {
            this.$message({ type: "error", message: res.data.error.message });
            isLoading = false;
          }
        })
        .catch({})
        .then(() => {
          this.loading = false;
        });
    },
    scroll() {
      window.onscroll = () => {
        let bottomOfWindow =
          document.documentElement.offsetHeight -
            document.documentElement.scrollTop -
            window.innerHeight <=
          0;
        if (bottomOfWindow && isLoading == false) {
          isLoading = true;
          let calculationSkipCount = 0;
          if (this.socialData != null) {
            calculationSkipCount = this.socialData.length;
          }
          this.scrollParam.SkipCount = calculationSkipCount;
          this.scrollParam.MaxResultCount = limit;
          this.$api.social
            .GetMySocialData(this.scrollParam)
            .then((result) => {
              result.data.result.items.map((item, index) => {
                socialTool.setPlayer(
                  this.playerOptions,
                  this.noChangeVideoList,
                  item.id,
                  item.fileUrl,
                  false,
                  this.IsNullOrEmpty(item.sgL_ImageTempURL)
                    ? item.jietuFileUrl
                    : item.sgL_ImageTempURL
                );
                this.socialData.push(item);
              });
              if (result.data.result.items.length > 0) {
                currentPage++;
              }
              isLoading = false;
            })
            .catch((e) => {
              isLoading = false;
            });
        }
      };
    },
  },
  created() {
    this.loginUser = this.$store.getters.getcustomer;
    this.getPageData();
  },
  mounted() {
    this.scroll();
  },
  destroyed() {
    window.onscroll = null;
  },
};
</script>

<style scoped>
.social_feed_date {
  text-align: center;
  width: 100%;
  border: 0;
  padding-top: 0px;
  padding-bottom: 10px;
}
.social_feed_date .el-date-editor {
  width: 100%;
}

.feedpost {
  z-index: 1;
}
.feedpost .mask {
  z-index: 2;
}
.feedpost >>> .reportMask {
  background-color: rgba(1, 0, 0, 0.6);
}
.hideBtn >>> .vjs-big-play-button {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/Social/MyDynamic.vue